import React from "react";
import { Singleton } from "helper/tools";
import createOrdenStyles from "./createOrden.module.css";
import styles from "./../tooltip.module.css";
import { FaRegCircleXmark, FaPercent } from "react-icons/fa6";

function ProductoCard({
  item,
  index,
  ordenBlocked,
  loadBonificacion,
  removeProduct,
  updateProduct,
}) {
  const nombre = item.nombre;
  const marca = item.marca?.nombre ?? "";

  const precio = Singleton.getInstance().format(item.precio);
  const maxCantidad = item.maxCantidad;
  const cantidad = item.cantidad;
  const subTotal = Singleton.getInstance().format(item.subTotal);

  const canPulse = item.canPulse ? "pulse-glow" : "";

  return (
    <>
      <tr className={`${createOrdenStyles.tablecenter} ${canPulse}`}>
        <th scope="row">{nombre}</th>
        <td>{marca}</td>
        <td
          style={{
            textAlign: "center",
          }}
        >
          {precio}
        </td>
        <td>
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "block",
            }}
          >
            <input
              style={{
                width: "100%",
                textAlign: "center",
              }}
              type="number"
              min="1"
              step="1"
              value={cantidad}
              max={maxCantidad}
              onChange={(e) => {
                //
                updateProduct(index, parseInt(e.currentTarget.value));
              }}
              disabled={ordenBlocked}
            />
          </div>
        </td>

        <td
          style={{
            textAlign: "center",
          }}
        >
          {subTotal}
        </td>
        <td>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <>
              <button
                className={`btn btn-warning ${styles.tooltip}`}
                disabled={ordenBlocked}
                onClick={(event) => {
                  console.log("--->removeProduct");
                  loadBonificacion(item);
                }}
                style={{
                  marginLeft: "0px",
                  marginRight: "5px",
                }}
                type="button"
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Bonificación</span>
                  <FaPercent />
                </div>
              </button>
              <button
                className={`btn btn-danger ${styles.tooltip}`}
                onClick={(event) => {
                  console.log("--->removeProduct");

                  removeProduct(index);
                }}
                style={{ marginLeft: "0px" }}
                type="button"
                disabled={ordenBlocked}
              >
                <div>
                  <span className={`${styles.tooltiptext}`}>Eliminar</span>
                  <FaRegCircleXmark />
                </div>
              </button>
            </>
          </div>
        </td>
      </tr>
      {item.bonificaciones &&
        item.bonificaciones.map((e, index) => {
          return (
            <tr key={index}>
              <td
                colSpan="5"
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                Bonificación
              </td>
              <td
                style={{
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {e.promocion.codigo}
              </td>
              <td colSpan={2}></td>
            </tr>
          );
        })}
    </>
  );
}

export default ProductoCard;
